/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrescriptionResponseDto
 */
export interface PrescriptionResponseDto {
    /**
     * Prescription ID
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    id: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    patientId: string;
    /**
     * Price
     * @type {number}
     * @memberof PrescriptionResponseDto
     */
    price: number;
    /**
     * Patient first name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    patientFirstName: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    patientLastName: string;
    /**
     * Patient email
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    patientEmail: string;
    /**
     * Provider first name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    providerId: string;
    /**
     * Provider first name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    providerFirstName: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    providerLastName: string;
    /**
     * Provider email
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    providerEmail: string;
    /**
     * Status
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    status: PrescriptionResponseDtoStatusEnum;
    /**
     * Created at
     * @type {Date}
     * @memberof PrescriptionResponseDto
     */
    createdAt: Date;
    /**
     * Practice ID
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    practiceId?: string;
    /**
     * Practice name
     * @type {string}
     * @memberof PrescriptionResponseDto
     */
    practiceName?: string;
}


/**
 * @export
 */
export const PrescriptionResponseDtoStatusEnum = {
    Cancelled: 'cancelled',
    Paid: 'paid',
    Pending: 'pending'
} as const;
export type PrescriptionResponseDtoStatusEnum = typeof PrescriptionResponseDtoStatusEnum[keyof typeof PrescriptionResponseDtoStatusEnum];


/**
 * Check if a given object implements the PrescriptionResponseDto interface.
 */
export function instanceOfPrescriptionResponseDto(value: object): value is PrescriptionResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('patientFirstName' in value) || value['patientFirstName'] === undefined) return false;
    if (!('patientLastName' in value) || value['patientLastName'] === undefined) return false;
    if (!('patientEmail' in value) || value['patientEmail'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    if (!('providerFirstName' in value) || value['providerFirstName'] === undefined) return false;
    if (!('providerLastName' in value) || value['providerLastName'] === undefined) return false;
    if (!('providerEmail' in value) || value['providerEmail'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PrescriptionResponseDtoFromJSON(json: any): PrescriptionResponseDto {
    return PrescriptionResponseDtoFromJSONTyped(json, false);
}

export function PrescriptionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrescriptionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'price': json['price'],
        'patientFirstName': json['patientFirstName'],
        'patientLastName': json['patientLastName'],
        'patientEmail': json['patientEmail'],
        'providerId': json['providerId'],
        'providerFirstName': json['providerFirstName'],
        'providerLastName': json['providerLastName'],
        'providerEmail': json['providerEmail'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
        'practiceName': json['practiceName'] == null ? undefined : json['practiceName'],
    };
}

export function PrescriptionResponseDtoToJSON(json: any): PrescriptionResponseDto {
    return PrescriptionResponseDtoToJSONTyped(json, false);
}

export function PrescriptionResponseDtoToJSONTyped(value?: PrescriptionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'price': value['price'],
        'patientFirstName': value['patientFirstName'],
        'patientLastName': value['patientLastName'],
        'patientEmail': value['patientEmail'],
        'providerId': value['providerId'],
        'providerFirstName': value['providerFirstName'],
        'providerLastName': value['providerLastName'],
        'providerEmail': value['providerEmail'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'practiceId': value['practiceId'],
        'practiceName': value['practiceName'],
    };
}

